import { Pipe, PipeTransform } from '@angular/core';
import { AppContext } from '../services/context/app.context.service';
import { CURRENCY_MAPPER } from '../mappers/currency.mapper';
import { formatCurrency } from '@angular/common';
import { CURRENCY_SECONDARY_DEFAULT_FORMAT } from '../types/enums';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {
  constructor(private readonly _appCtxSvc: AppContext) {}

  transform(value: any, type: 'primary' | 'secondary' = 'primary'): string {
    try {
      const country = this._appCtxSvc.getCountry();
      
      const _currencyToShow = type === 'primary' ? CURRENCY_MAPPER[country] : CURRENCY_SECONDARY_DEFAULT_FORMAT;
      const currencyformat = formatCurrency(value < 0 ? (value*-1) : value, `en-US`, _currencyToShow, _currencyToShow, undefined);
      //to get a space between currency code and value (ex. MXN 100.00)
      let formatVal = `${currencyformat.substring(0, 3)} ${value < 0 ? '-' : ''}${currencyformat.substring(3, currencyformat.length)}`
      return formatVal;
    } catch (error) {
      throw error;
    }
  }
}
